import { css } from '@emotion/core';
import { media, tokens, variables } from '@domain-group/fe-brary';
var global = variables.global;
export var listingCards = /*#__PURE__*/css("margin:24px 16px 0;", media('>=desktop'), "{width:", global.desktopMinWidth, ";margin:24px 0 0 0;}");
export var separator = /*#__PURE__*/css("margin:56px 0 ", tokens.spacing.l, ";");
export var recommendations = /*#__PURE__*/css("padding-bottom:5px;", media('<desktop'), "{padding:0 16px 5px;}", media('>=tablet'), "{display:flex;flex-direction:row;gap:24px;}");
export var sticky = /*#__PURE__*/css("padding-top:24px;", media('<desktop'), "{display:none;}");